import React from 'react';
import PropTypes from 'prop-types';
import checkMarkIconWhite from 'assets/icons/checkmark-white.svg';
import IconProtectionPlan from 'components/icons/iconProtectionPlan';
import IconPetProtector from 'components/icons/iconPetProtector';
import JBImage from 'components/essentials/JBImage';

const ListItem = desc => {
  // removing strong from 'Everything in the life happens plan';
  let theDesc = desc;
  theDesc = theDesc.replace('<strong>', '').replace('</strong>', '');
  return (
    <li>
      <JBImage
        className="check"
        src={checkMarkIconWhite}
        width={16}
        alt="check"
      />
      <span>{theDesc}</span>
    </li>
  );
};

const ProtectionPlanVariant = ({
  backgroundImg = '',
  planType = 'protection',
  planItems = [],
  planName = '',
}) => (
  <div
    className="text-base text-white bg-brand-dark [background-image:url(https://joybird2.imgix.net/user-uploads-staging/joybird-teal-new.jpg?w=400&cs=srgb)] bg-cover p-4 text-left flex flex-col font-bold [&_span]:block [&_ul]:mt-4 [&_ul]:mx-0 [&_ul]:mb-0 [&_ul]:min-h-[9rem] [&_ul_li]:text-base [&_ul_li]:flex [&_ul_li]:pb-[.15rem] [&_ul_li]:list-none [&_ul_li_img]:pr-[.2rem] [&_ul_li_img]:mr-[.325rem]"
    style={{
      backgroundImage: backgroundImg ? `url(${backgroundImg})` : null,
    }}
  >
    <div className="ProtectionPlanVariant__protection-plan">
      <div className="[&_svg]:fill-brand-dark">
        {planType === 'pet' ? (
          <IconPetProtector />
        ) : (
          <IconProtectionPlan circleFill="#016a78" fill="#fff" />
        )}
      </div>
      <span className="text-xl font-bold w-full tracking-[.2px] md:text-2xl md:font-bold">
        5-year Protection Plan
      </span>
      <span className="text-base font-bold mb-2 md:text-[.8rem]">
        When an accident happens, know your investment is protected.
      </span>

      <span className="text-lg font-bold">{planName}</span>
      <ul>
        {planItems.map(desc => (
          <ListItem key={desc} desc={desc} />
        ))}
      </ul>
      <span className="text-sm font-bold">In partnership with ServeCo.</span>
    </div>
  </div>
);

ProtectionPlanVariant.propTypes = {
  backgroundImg: PropTypes.string,
  planType: PropTypes.string,
  planItems: PropTypes.array,
  planName: PropTypes.string,
};

export default ProtectionPlanVariant;
